module.exports = __webpack_public_path__ + "static/media/34.4a150ae0.jpg";